import * as React from "react";
import type { SVGProps } from "react";
const SvgMenu2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3 11a1 1 0 1 0 0 2zm14 2a1 1 0 1 0 0-2zM3 5a1 1 0 0 0 0 2zm18 2a1 1 0 1 0 0-2zM3 17a1 1 0 1 0 0 2zm18 2a1 1 0 1 0 0-2zM3 13h14v-2H3zm0-6h18V5H3zm0 12h18v-2H3z"
    />
  </svg>
);
export default SvgMenu2;
